<h2>Feed Mapping – {{ destination | uppercase }}</h2>

<p>Map your product fields to the fields required for {{ destination }}.</p>

<form [formGroup]="form">

  <table class="mapping-table">
    <thead>
      <tr>
        <th>Destination Field</th>
        <th>Required</th>
        <th>Mapped Field</th>
        <th>Default Value</th>
        <th>Transformation (optional)</th>
      </tr>
    </thead>

    <tbody formArrayName="mappings">
      <tr *ngFor="let row of mappingsArray.controls; let i = index" [formGroupName]="i">
        
        <td>{{ row.value.field_name }}</td>

        <td>
          <span *ngIf="row.value.required">✔ Required</span>
          <span *ngIf="!row.value.required">Optional</span>
        </td>

        <td>
          <select formControlName="mapped_field">
            <option value="">— None —</option>

            <optgroup label="Product Fields">
              <option
                *ngFor="let f of productFields"
                [value]="f.key">
                {{ f.label }}
              </option>
            </optgroup>

            <optgroup label="Computed Fields">
              <option
                *ngFor="let f of computedFields"
                [value]="f.key">
                {{ f.label }}
              </option>
            </optgroup>
          </select>
        </td>

        <td>
          
            <div *ngIf="row.value.field_name === 'link'" class="with-info-icon">
          <input
            formControlName="default_value"
            [placeholder]='"/products/{{product_id}}"'
          />

          <mat-icon
            matTooltip="Use a relative product path, not including the Domain. Ex. /products/{{'{{product_id}}'}}"
            matTooltipPosition="right"
            matTooltipClass="feed-tooltip"
          >
            <i class="bi bi-info-circle-fill"></i>
          </mat-icon>
          </div>
          <div *ngIf="row.value.field_name != 'link'">
            <input formControlName="default_value" placeholder="Fallback value" />
          </div>
          
        </td>

        <td>
          <input formControlName="transformation" placeholder="e.g., UPPERCASE(), CONCAT(...)" />
        </td>

      </tr>
    </tbody>
  </table>

  <button class="save-btn" (click)="saveMappings()">Save Mappings</button>
  <button class="cancel-btn" mat-button color="warn" [routerLink]="['/admin/manage-feeds']">Cancel</button>

</form>
